export default __webpack_public_path__ + "static/media/1280x500_02.a403b492.jpg";